import { LitElement as p, unsafeCSS as _ } from "lit";
import { property as h } from "lit/decorators.js";
import { booleanType as c } from "../../utils/property-types.js";
import v from "./slider.style.css.js";
import { template as m } from "./slider.template.js";
var b = Object.defineProperty, E = Object.getOwnPropertyDescriptor, o = (u, t, e, r) => {
  for (var s = E(t, e), i = u.length - 1, n; i >= 0; i--)
    (n = u[i]) && (s = n(t, e, s) || s);
  return s && b(t, e, s), s;
};
class a extends p {
  // _bubble = this.renderRoot.querySelector('#dssSliderValue')
  constructor() {
    super(), this._label = "Input range", this._min = 0, this._max = 0, this._step = 1, this._orient = "horizontal", this._vertical = !1, this._value = 0, this._progress = 0, this._disabled = !1, this._isTooltipTouched = !1, this._handleDomContentLoaded = this._updateTooltip.bind(this), this._handleInputEvent = this._updateTooltip.bind(this), this._handleMouseUp = this._dispatchValue.bind(this), this._handleKeyUp = this._dispatchValue.bind(this), this._handleTouchStartEvent = this._handleTouchStart.bind(this), this._handleTouchMoveEvent = this._handleTouchMove.bind(this), this._handleTouchEndEvent = this._handleTouchEnd.bind(this);
  }
  static get styles() {
    return _(v);
  }
  get _input() {
    var t;
    return (t = this.shadowRoot) == null ? void 0 : t.querySelector("input");
  }
  get _tooltip() {
    var t;
    return (t = this.shadowRoot) == null ? void 0 : t.querySelector("#dss-slider-tooltip");
  }
  set min(t) {
    const e = this._min;
    this._min = t, this.requestUpdate("min", e);
  }
  get min() {
    return this._min;
  }
  set max(t) {
    const e = this._max;
    t >= this._value && (this._max = t, this._setProgress(), this.requestUpdate("max", e));
  }
  get max() {
    return this._max;
  }
  set step(t) {
    const e = this._step;
    this._step = t, this.requestUpdate("step", e);
  }
  get step() {
    return this._step;
  }
  set orient(t) {
    const e = this._orient;
    this._orient = t, t === "vertical" ? this._vertical = !0 : this._vertical = !1, this.requestUpdate("orient", e);
  }
  get orient() {
    return this._orient;
  }
  set value(t) {
    const e = this._value;
    this._max >= t && (this._value = t, this._setProgress(), this.requestUpdate("value", e));
  }
  get value() {
    return this._value;
  }
  set disabled(t) {
    const e = this._disabled;
    this._disabled = t, this.requestUpdate("disabled", e);
  }
  get disabled() {
    return this._disabled;
  }
  set label(t) {
    const e = this._label;
    this._label = t, this.requestUpdate("label", e);
  }
  get label() {
    return this._label;
  }
  async firstUpdated() {
    try {
      await this.updateComplete, this._setProgress(), this.requestUpdate(), document.addEventListener("DOMContentLoaded", this._handleDomContentLoaded), this._input.addEventListener("input", this._handleInputEvent), this._input.addEventListener("mouseup", this._handleMouseUp), this._input.addEventListener("keyup", this._handleKeyUp), this._input.addEventListener("touchstart", this._handleTouchStartEvent), this._input.addEventListener("touchmove", this._handleTouchMoveEvent), this._input.addEventListener("touchend", this._handleTouchEndEvent);
    } catch {
      console.error("ERROR OCURRED");
    }
  }
  disconnectedCallback() {
    var t, e, r, s, i, n;
    super.disconnectedCallback(), document.removeEventListener("DOMContentLoaded", this._handleDomContentLoaded), (t = this._input) == null || t.removeEventListener("input", this._handleInputEvent), (e = this._input) == null || e.removeEventListener("mouseup", this._handleMouseUp), (r = this._input) == null || r.removeEventListener("keyup", this._handleKeyUp), (s = this._input) == null || s.removeEventListener("touchstart", this._handleTouchStartEvent), (i = this._input) == null || i.removeEventListener("touchmove", this._handleTouchMoveEvent), (n = this._input) == null || n.removeEventListener("touchend", this._handleTouchEndEvent);
  }
  _handleTouchStart(t) {
    this._vertical && t.preventDefault(), this._isTooltipTouched = !0;
  }
  _handleTouchEnd(t) {
    this._vertical && t.preventDefault(), this._isTooltipTouched = !1, this.requestUpdate(), this._dispatchValue();
  }
  _handleTouchMove(t) {
    if (this._vertical) {
      if (!t.target) return;
      const e = t.target, r = Number.parseInt(e.max, 10), s = Number.parseInt(e.min, 10), i = t.touches[0], n = e.getBoundingClientRect(), l = (i.clientY - n.top) / n.height, d = Math.round(l * (r - s) + s);
      e.value = String(r - d + s), e.dispatchEvent(new Event("input"));
    }
  }
  _handleInput() {
    if (this._input) {
      const t = Number.parseFloat(this._input.value);
      this._progress = Math.round((t - this._min) / (this._max - this._min) * 100), this.requestUpdate();
    }
  }
  _setProgress() {
    this._input && (this._input.value = this._value.toString()), this._progress = Math.round((this._value - this._min) / (this._max - this._min) * 100), this.requestUpdate();
  }
  _updateTooltip() {
    if (this._tooltip) {
      const t = Number((+this._input.value - +this._min) * 100 / (+this._max - +this._min)), e = 10 - t * 0.2;
      this._tooltip.innerHTML = `<span class="tooltip-wrapper"><span class="tooltip-value">${this._input.value}</span></span>`, this._tooltip.style.left = `calc(${t}% + (${e}px))`;
    }
  }
  _dispatchValue() {
    const t = {
      detail: this._input.value,
      bubbles: !0,
      composed: !0
    };
    this.dispatchEvent(new CustomEvent("onDssSliderValueChange", t));
  }
  render() {
    return m(this);
  }
}
o([
  h({ type: Number })
], a.prototype, "min");
o([
  h({ type: Number })
], a.prototype, "max");
o([
  h({ type: Number })
], a.prototype, "step");
o([
  h({ type: String })
], a.prototype, "orient");
o([
  h({ type: Number })
], a.prototype, "value");
o([
  h(c)
], a.prototype, "disabled");
o([
  h({ type: String })
], a.prototype, "label");
export {
  a as Slider
};
//# sourceMappingURL=slider.js.map
